import {
  Baby,
  BookOpen,
  CreditCard,
  Dumbbell,
  Film,
  Fish,
  Gamepad2,
  Gift,
  GraduationCap,
  Hammer,
  Landmark,
  Leaf,
  MapPin,
  Monitor,
  Palmtree,
  Plane,
  RollerCoaster,
  ShoppingBag,
  Sparkles,
  Store,
  Tent,
  Ticket,
  TicketCheck,
  Trees,
  Utensils,
  Waves,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

const CATALOGUE_ICON_MAP: Record<string, LucideIcon> = {
  loisirs: Ticket,
  cadeaux: Gift,
  cinémas: Film,
  cinemas: Film,
  voyages: Plane,
  culture: BookOpen,
  sport: Dumbbell,
  billetterie: TicketCheck,
};

const GENRE_ICON_MAP: Record<string, LucideIcon> = {
  // Catalogue Cadeaux
  "abonnement digital, multimédia": Monitor,
  "abonnement digital, multimedia": Monitor,
  "alimentation, gastronomie": Utensils,
  "brico, déco, aménagement": Hammer,
  "brico, deco, amenagement": Hammer,
  "chèques culture": BookOpen,
  "cheques culture": BookOpen,
  "cours en ligne, coaching": GraduationCap,
  "déco, meuble, aménagement": Hammer,
  "deco, meuble, amenagement": Hammer,
  "jeux, livres, puériculture": Baby,
  "jeux, livres, puericulture": Baby,
  "loisirs": Gamepad2,
  "mode, beauté, parfumerie": Sparkles,
  "mode, beaute, parfumerie": Sparkles,
  "multi-enseigne, gd distrib": Store,
  "nouveautés": Gift,
  "nouveautes": Gift,
  "produits artisanaux": Leaf,
  "sport": Dumbbell,
  "voyages": Plane,

  // Catalogue Cinémas
  "abonnements": CreditCard,
  "billets papier": Ticket,
  "e-billets": Ticket,

  // Catalogue Parcs & Loisirs
  "aquariums": Fish,
  "e-billets parcs": Ticket,
  "grands parcs": RollerCoaster,
  "loisirs & tourisme": MapPin,
  "loisirs et tourisme": MapPin,
  "offres séjours": Palmtree,
  "offres sejours": Palmtree,
  "parcs animaliers": Trees,
  "parcs aquatiques": Waves,
  "parcs culturels": Landmark,
  "parcs d'attractions": RollerCoaster,
  "zoos et parcs animaliers": Trees,
  "campings": Tent,
  "cartes cadeaux": CreditCard,
  "carte cadeau": CreditCard,
};

export const getCatalogueIcon = (catalogueName: string): LucideIcon => {
  const normalizedName = catalogueName.toLowerCase().trim();
  return CATALOGUE_ICON_MAP[normalizedName] ?? ShoppingBag;
};

export const getGenreIcon = (genreName: string): LucideIcon => {
  const normalizedName = genreName.toLowerCase().trim();
  return GENRE_ICON_MAP[normalizedName] ?? ShoppingBag;
};
